import React from 'react';
import * as Styles from './Resources.styles';
import { Skeleton } from 'gatorcomponents';
import CardResource from './Cards/CardResource';
import CardResourceImage from './Cards/CardResourceImage';
import { RESOURCES_ELEMENTS } from '../../HomeHandler.enum';
import withErrorBoundary from '@/utils/errorBoundary';

const Resources = ({ elementsResources, width }) => {
  if (!elementsResources) {
    return (
      <Styles.ResourcesSkeletonWrapper data-testid="resources-skeleton-wrapper" width={width}>
        <Styles.FirstResourceWrapper>
          <Skeleton width="170px" variant="textLine" />
          <Skeleton width="170px" variant="textLine" />
        </Styles.FirstResourceWrapper>
        <Styles.ResourceWrapper>
          <Skeleton width="60px" height="60px" variant="circle" />
          <Skeleton width="170px" height="32px" variant="textLine" />
        </Styles.ResourceWrapper>
        <Styles.ResourceWrapper>
          <Skeleton width="60px" height="60px" variant="circle" />
          <Skeleton width="170px" height="32px" variant="textLine" />
        </Styles.ResourceWrapper>
        <Styles.ResourceWrapper>
          <Skeleton width="60px" height="60px" variant="circle" />
          <Skeleton width="170px" height="32px" variant="textLine" />
        </Styles.ResourceWrapper>
      </Styles.ResourcesSkeletonWrapper>
    );
  }

  return (
    <Styles.WrapperResources width={width} data-testid="resources-wrapper">
      {elementsResources.map(element => (
        element.name === RESOURCES_ELEMENTS.CARD_RESOURCE_IMAGE
          ? <CardResourceImage element={element} key={`${element.name}-${element.title.replace(/\s+/g, '-').toLowerCase()}`} />
          : <CardResource element={element} key={`${element.name}-${element.title.replace(/\s+/g, '-').toLowerCase()}`} />
      ))}
    </Styles.WrapperResources>
  );
};

export default withErrorBoundary(Resources, 'Resources');
